// extracted by mini-css-extract-plugin
export default {"self":"InboxMassOfferingsLayout-module--self--myWmk","footerWrapper":"InboxMassOfferingsLayout-module--footerWrapper--NHCSt"};